import { DarkEmail, Email } from "common/Icons/Icons.tsx";
import { useTheme } from "styled-components";
import React from "react";
import VerificationCode from "features/auth/VerificationCode.tsx";
import { sharedLib } from "@shared/services/shared.service.ts";
import { displayResultMessage } from "utils/misc.tsx";
import { SECURITY_SETTINGS_PATH } from "common/constants.ts";
import { useHistory } from "react-router-dom";
import Text from "common/Typography/Text.tsx";
import { ICON_STYLE } from "features/settings/Security/ConnectEmail/EmailAndPassword.tsx";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation.ts";
import { LanguageNameSpaces } from "@shared/types";

interface VerifyEmailProps {
  email: string;
  emailValidatorUuid: string;
}

const VerifyEmail = ({ email, emailValidatorUuid }: VerifyEmailProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.SETTINGS);
  const theme = useTheme();
  const [confirmEmailConnection, { isLoading }] =
    sharedLib.sharedApi.settings.useConfirmEmailConnectionMutation();
  const history = useHistory();

  const Icon = theme.isDarkMode ? DarkEmail : Email;

  const onSubmit = (code: string) => {
    displayResultMessage(
      confirmEmailConnection({
        auth_code: code,
        email_validator_uuid: emailValidatorUuid,
      }).unwrap(),
      t("connect_email.success_message"),
      t("connect_email.error_message")
    )
      .then(() => {
        history.replace(SECURITY_SETTINGS_PATH);
      })
      .catch(() => {});
  };

  return (
    <div>
      {!theme.isNewLook && <Icon style={ICON_STYLE} />}
      <Text style={{ marginBottom: -16 }}>
        {t("connect_email.provide_code_from_email", { email })}
      </Text>
      <VerificationCode
        numOfDigits={6}
        title={t("connect_email.verification_code")}
        onSubmit={onSubmit}
        isLoading={isLoading}
      />
    </div>
  );
};

export default VerifyEmail;
